var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"wrapper"}},[_c('Header'),_c('router-view'),_c('Footer'),_c('div',{staticClass:"icon-angle-up",attrs:{"id":"gotoTop"}}),_c('ImageFilter'),_c('VModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }